module.exports = __webpack_public_path__ + "img/logo.145d27d3.png";